module.exports = __webpack_public_path__ + "56ec72c020920fc12b364a7ab0381661.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/hochformat/03.jpg
// module id = 140
// module chunks = 0